module.exports = __webpack_public_path__ + "img/32.fa0a912c.jpg";